import React, { useState } from "react";
import "./Referrals.css";

const ClientDashboardReferrals = () => {
  return (
    <div className="clientdashboard__referrals_section">
      <div className="clientdashboard__referrals_wrapper">
        <div className="clientdashboard__referrals_banner">Referrals</div>
        <div className="clientdashboard__referrals_tablewrap">
          <table className="clientdashboard__referrals_table">
            <thead className="clientdashboard__referrals_thead">
              <tr>
                <td>Sl. No.</td>
                <td>Friend Name</td>
                <td>Friend Email</td>
                <td>Phone</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>012</td>
                <td>John Doe</td>
                <td>johndoe@gmail.com</td>
                <td>+91 322 6578524</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="clientdashboard__referrals_bottombtnwrap">
          <button className="clientdashboard__referrals_makepaymentbtn">
            Make Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardReferrals;
